import('./view_switch_component.scss')
